import { IndexableObject } from "./Helpers";
import { ConditionedAttribute } from "./Conditional/HelpersConditional";
import React from "react";

interface TreeDataContextProps {
  treeData: IndexableObject;
  setTreeData: (newTreeData: IndexableObject) => void;
  getAllComponentNames: () => string[];
}

interface TreeSaveContextProps {
  saveChangesAtPath: (value: any, path: string[]) => void;
  removeAtPath: (path: string[]) => void;
  addGamePiece: (gamePieceName: string, gamePieceValue: any) => void;
}

export const TreeDataContext = React.createContext<TreeDataContextProps>({
  treeData: {},
  setTreeData: () => {},
  getAllComponentNames: () => {
    return [];
  },
});

export const TreeModifyContext = React.createContext<TreeSaveContextProps>({
  saveChangesAtPath: () => {},
  removeAtPath: () => {},
  addGamePiece: () => {},
});

export const useTreeDataContext = () => React.useContext(TreeDataContext);
export const useTreeModifyContext = () => React.useContext(TreeModifyContext);
